import { ITime } from '../models/time';

const minutesInHour = 60;
const hoursInDay = 24;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInDay = 86400000;

export function millisecondsToTime(duration: number): ITime {
  const minutes = Math.floor((duration / millisecondsInMinute) % minutesInHour);
  const hours = Math.floor((duration / millisecondsInHour) % hoursInDay);
  const days = Math.floor(duration / millisecondsInDay);
  return { days, hours, minutes };
}
